import { Component } from '@angular/core';
import { NgFor } from '@angular/common';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faBook, faGlobe } from '@fortawesome/free-solid-svg-icons';

interface LocalHealthAuthority {
  id: string;
  url: string;
  image: string;
}

@Component({
  selector: 'app-digital-doorway-landing',
  standalone: true,
  imports: [NgFor, TranslatePipe, FaIconComponent],
  templateUrl: './digital-doorway-landing.component.html',
})
export class DigitalDoorwayLandingComponent {
  readonly faBook = faBook;
  readonly faGlobe = faGlobe;

  readonly authorities: LocalHealthAuthority[] = [
    { id: 'centro', url: 'https://cat.eu.visitnow.org/08b68416-892b-4be4-807b-4bca87f98cf5', image: 'content/images/center.png' },
    { id: 'nord-ovest', url: 'https://cat.eu.visitnow.org/dc3b0044-2147-4a92-a43d-7463589f6241', image: 'content/images/Picture2.png' },
    { id: 'sud-est', url: 'https://cat.eu.visitnow.org/f9760408-bca9-4c1b-a1dc-63208e10b180', image: 'content/images/west.png' },
  ];

  constructor(public translate: TranslateService) {}

  switchLanguage(lang: 'en' | 'it') {
    this.translate.use(lang);
  }
}
